module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [(_vm.gettingData) ? _c('v-flex', [_c('v-card', {
    staticClass: "pa-2 ma-1 text-xs-center",
    attrs: {
      "to": "/JobList"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 60,
      "width": 8,
      "color": "primary",
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Fetching Recent Job Status")])], 1)], 1) : [_c('v-flex', [_c('v-card', {
    staticClass: "pa-2 ma-1 text-xs-center",
    attrs: {
      "to": "/JobList"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 60,
      "width": 8,
      "rotate": 360,
      "value": _vm.jobsNotStarted / _vm.data.length * 100,
      "color": "primary"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.jobsNotStarted) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("Jobs Not Started")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', {
    staticClass: "pa-2 ma-1 text-xs-center",
    attrs: {
      "to": "/JobList"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 60,
      "width": 8,
      "rotate": 360,
      "value": _vm.jobsStarted / _vm.data.length * 100,
      "color": "info"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.jobsStarted) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("Jobs Started")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', {
    staticClass: "pa-2 ma-1 text-xs-center",
    attrs: {
      "to": "/Outbox"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 60,
      "width": 8,
      "rotate": 360,
      "value": _vm.jobsNotUploaded / _vm.data.length * 100,
      "color": "error"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.jobsNotUploaded) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("Jobs Not Uploaded")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', {
    staticClass: "pa-2 ma-1 text-xs-center",
    on: {
      "click": function($event) {
        _vm.completedDialog = true
      }
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 60,
      "width": 8,
      "rotate": 360,
      "value": _vm.jobsCompleted / _vm.data.length * 100,
      "color": "success"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.jobsCompleted) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("Jobs Completed Last 14 Days")])], 1)], 1)], _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.completedDialog),
      callback: function($$v) {
        _vm.completedDialog = $$v
      },
      expression: "completedDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("Completed Jobs Last 14 Days")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.completedDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _vm._l((_vm.completedJobs), function(job, i) {
    return _c('v-list', {
      key: i,
      staticClass: "green mb-2",
      attrs: {
        "dark": "",
        "three-line": ""
      }
    }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(job.Vehicle ? _vm.vehicleRegFromID(job.Vehicle) : job.vehReg))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Job ID: " + _vm._s(job.JobNo))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Completed: " + _vm._s(_vm._f("formatDate")(job.CompletedDate)))])], 1)], 1)], 1)
  })], 2)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bd9f832","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/StatusOverview.vue
// module id = 667
// module chunks = 1